import React from 'react';
import './JoinCult.css';

const JoinCult = () => {
  return (
    <section className="join-cult-section">
      <div className="join-cult-container">
        <div className="join-cult-header">
          <h2>[Y]our Ideology</h2>
          <p className="join-cult-subtitle">
            We're not just making camouflage. We're building a movement.
          </p>
        </div>
        
        <div className="ideology-list">
          <div className="ideology-item">
            <div className="ideology-bullet">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 12L9 6L12 9L15 6L21 12L15 18L12 15L9 18L3 12Z" fill="currentColor"/>
              </svg>
            </div>
            <div className="ideology-content">
              <h3>Mass Production is Not The Answer</h3>
              <p>
                Mass-produced patterns can't capture the unique character of every environment. 
                We're breaking free from the one-size-fits-all approach that's been holding 
                hunters and outdoor enthusiasts back for decades.
              </p>
            </div>
          </div>
          
          <div className="ideology-item">
            <div className="ideology-bullet">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.71 7.04C21.1 6.65 21.1 6 20.71 5.63L18.37 3.29C18 2.9 17.35 2.9 16.96 3.29L15.12 5.12L18.87 8.87L20.71 7.04M3 17.25V21H6.75L17.81 9.93L14.06 6.18L3 17.25Z" fill="currentColor"/>
              </svg>
            </div>
            <div className="ideology-content">
              <h3>Everyone Can Be a Designer</h3>
              <p>
                You don't need a degree in design to create meaningful camouflage. 
                If you know your environment, you can design for it. Our platform 
                democratizes design, putting the power in the hands of those who 
                truly understand their terrain.
              </p>
            </div>
          </div>
          
          <div className="ideology-item">
            <div className="ideology-bullet">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2A10 10 0 0 0 2 12A10 10 0 0 0 12 22A10 10 0 0 0 22 12A10 10 0 0 0 12 2M12 4A8 8 0 0 1 20 12A8 8 0 0 1 12 20A8 8 0 0 1 4 12A8 8 0 0 1 12 4M12 6A6 6 0 0 0 6 12A6 6 0 0 0 12 18A6 6 0 0 0 18 12A6 6 0 0 0 12 6M12 8A4 4 0 0 1 16 12A4 4 0 0 1 12 16A4 4 0 0 1 8 12A4 4 0 0 1 12 8Z" fill="currentColor"/>
              </svg>
            </div>
            <div className="ideology-content">
              <h3>Every Environment Deserves Its Pattern</h3>
              <p>
                From urban concrete to desert sand, every landscape has unique 
                characteristics that demand custom camouflage solutions. We believe 
                in honoring the diversity of our natural world through thoughtful, 
                purpose-driven design.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinCult; 